import { GlobalStore } from '@driftt/traffic-control'
import { CustomerAPI } from 'api'

export const updateUserSettings = async (properties) => (
  CustomerAPI.patch(`users/${GlobalStore.getState().user.id}/properties`, properties)
)

export const setAccountsFollow = async follow => {
  return updateUserSettings({'follow_accounts': follow})
}

const executeOrgPropertyPatch = ({ orgId, driftPatchOperation }) => {
  return CustomerAPI.patch(`/organizations/${orgId}/properties2`, [ driftPatchOperation ])
}

export const setSecondaryOwnerProp = ({ orgId, secondaryAccountOwnerField }) => {
  const driftPatchOperation = {
    operation: 'set',
    property: 'secondaryAccountOwnerField',
    value: secondaryAccountOwnerField
  }
  return executeOrgPropertyPatch({ orgId, driftPatchOperation })
}

export const deleteSecondaryOwnerProp = ({ orgId }) => {
  const driftPatchOperation = {
    operation: 'remove',
    property: 'secondaryAccountOwnerField'
  }
  return executeOrgPropertyPatch({ orgId, driftPatchOperation })
}

export const getOrgProperties = () => (
  CustomerAPI.get(`organizations/properties`)
)
